export default "__VITE_ASSET__512f5480__"